import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule],
  selector: 'app-brwose-files',
  templateUrl: './brwose-files.component.html',
})
export class BrwoseFilesComponent implements OnInit {
  @Output() uploadFileEvent: EventEmitter<any> = new EventEmitter();
  isAcmic: boolean;
  constructor(private acmicService: AcmicService) {}

  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
  }

  uploadFile(event) {
    this.uploadFileEvent.emit(event);
  }
}
